import Alert from "./alert";
import { getCorrectedTime } from "../time";
import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function AlternateGameHeader({ myTickets, serverTimeDifference, tournament }) {
  var players = tournament.get("max_users") - tournament.get("remaining_entries");
  var needed = tournament.get("number_of_users_required") - players;
  var remainingMinutes = getRemainingMinutes(new Date(tournament.get("starts_at")), serverTimeDifference);
  if (tournament.get("status") === "open" &&
    tournament.get("alternate_active") &&
    needed > 0 &&
    remainingMinutes < 7) {
    return <MinimumPlayerAlert needed={needed} tournament={tournament} />;
  }

  if (tournament.get("status") !== "cancelled") {
    return null;
  }
  if (tournament.get("alternates").count() === 0) {
    return null;
  }
  if (myTickets.count() === 0) {
    return null;
  }

  var alternateUrl = "/tournaments/" + tournament.getIn(["alternates", 0]);
  var alternateName = tournament.get("alternate_name") || "Alternate Game";

  return (
    <div className="notification notification--subtle notification--error notification--is-visible">
      <div className="notification_content">
        <div className="notification_icon">
          <i className="dw-blocked" />
        </div>

        <div className="notification_body">
          <h2 className="notification_title">
            Sorry, this tournament was cancelled. But you have been entered into the
            {" "}

            <Link className="link--is-underlined" to={alternateUrl}>
              alternate game
            </Link>
            .
          </h2>

          <p>
            This game was cancelled because the minimum number of entries wasn&apos;t met.
          </p>

          <p>
            Alternate Game:
            {" "}

            <Link className="btn btn--transparent" to={alternateUrl}>
              {alternateName}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
});

function getRemainingMinutes(date, serverTimeDifference) {
  var corrected = getCorrectedTime(new Date(), serverTimeDifference);
  return Math.floor((date - corrected) / 1000 / 60);
}

var MinimumPlayerAlert = pure(function MinimumPlayerAlert({ needed, tournament }) {
  var title = "This game needs " + needed + " more " + (needed === 1 ? "entry" : "entries") + " to meet the minimum.";
  return (
    <Alert icon="dw-warning6" subtle title={title} type="notification--caution">
      <p>
        If it does not meet the minimum, players will be moved to the alternate game. See
        {" "}

        <a className="color--is-error link--is-underlined" href="http://blog.derbywars.com/official-rules-1/">
          rules
        </a>

        {" "}
        for details.
      </p>

      <p>
        Alternate Game:
        {" "}

        {tournament.get("alternate_name")}
      </p>
    </Alert>
  );
});
